
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 135.467 135.467","height":"512","width":"512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M42.73 63.7c14.923-13.4 21.562-12.118 33.344-19.257C90.72 35.568 95.425 20.73 88.514 17.06c-8.35-4.433-17.149 7.08-19.893 16.87-4.643 19.192-6.68 40.682-11.903 60.913-4.225 16.207-11.439 24.8-22.929 24.495-9.853-.261-12.369-6.161-11.94-9.6 1.023-8.208 12.759-13.261 30.14-5.84 9.645 4.116 16.403 12.438 30.061 13.39 8.435.589 19.634-2.7 31.543-16.21","fill":"none","stroke-linecap":"round","stroke-width":"12.7","stroke":"#e00b5d"}})])
          )
        }
      }
    